import api from '../utils/api';

const reportTemplatesService = {
  listTemplates: async () => {
    try {
      return await api.get('/api/report-templates');
    } catch (error) {
      console.error('Error fetching report templates:', error);
      throw error;
    }
  },

  createTemplate: async (data) => {
    try {
      return await api.post('/api/report-templates', data);
    } catch (error) {
      console.error('Error creating report template:', error);
      throw error;
    }
  },

  updateTemplate: async (templateId, data) => {
    try {
      return await api.put(`/api/report-templates/${templateId}`, data);
    } catch (error) {
      console.error('Error updating report template:', error);
      throw error;
    }
  },

  deleteTemplate: async (templateId) => {
    try {
      return await api.delete(`/api/report-templates/${templateId}`);
    } catch (error) {
      console.error('Error deleting report template:', error);
      throw error;
    }
  },

  setDefaultTemplate: async (templateId) => {
    try {
      return await api.post(`/api/report-templates/${templateId}/set-default`, {});
    } catch (error) {
      console.error('Error setting default report template:', error);
      throw error;
    }
  },
};

export default reportTemplatesService;
